import React, { useMemo } from "react";
import classNames from "classnames";
import HtmlText from "components/HtmlText";
import * as styles from "./styles.module.scss";
const AccuracyIcon = ({ accuracy = "", title, className }) => {
    const iconClassName = useMemo(() => String(accuracy).toLowerCase().trim().replace(/\s+/g, "-"), [accuracy]);
    return (React.createElement(HtmlText, { title: title, targetTagName: "div", targetClassName: classNames(styles[`accuracyIcon-${iconClassName}`], className), testId: "accuracy-icon" }));
};
export default AccuracyIcon;
